module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 container"
  }, [(_vm.errorMsg) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.alertMsg) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('p', [_vm._v(_vm._s(_vm.alertMsg))])]) : _vm._e(), _vm._v(" "), _c('h3', [_c('strong', [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pending),
      expression: "pending"
    }],
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.OldPassword),
      expression: "userData.OldPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Enter your old password"
    },
    domProps: {
      "value": (_vm.userData.OldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "OldPassword", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pending),
      expression: "pending"
    }],
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.NewPassword),
      expression: "userData.NewPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Enter your new password"
    },
    domProps: {
      "value": (_vm.userData.NewPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "NewPassword", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pending),
      expression: "pending"
    }],
    staticClass: "btn btn-title btn-success",
    on: {
      "click": function($event) {
        _vm.changePassword()
      }
    }
  }, [_vm._v("\n      Save\n    ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pending),
      expression: "pending"
    }],
    staticClass: "btn btn-title btn-default",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("\n      Cancel\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-477a37a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/ChangePassword.vue
// module id = 628
// module chunks = 2